import { defineMessages } from 'react-intl';

export const signUpPageMessages = defineMessages({
  logoAlt: {
    defaultMessage: 'Heidi',
    id: 'EPnGG0YTVl',
    description: 'Alt text for the Heidi logo on the onboarding signup page',
  },
  useHeidiSaveHours: {
    defaultMessage: 'Use Heidi, save hours',
    id: 'kWVsvBnxCI',
    description: 'Headline on the onboarding signup page',
  },
  signUpForFree: {
    defaultMessage: 'Sign up for free',
    id: '+ZSAX8Qpvi',
    description: 'Subtitle under the headline on the onboarding signup page',
  },
  termsAgreementWithLinks: {
    defaultMessage:
      'By using this product, you acknowledge and agree to abide by the <usagePolicy>Usage Policy</usagePolicy>, <privacyPolicy>Privacy Policy</privacyPolicy> and <termsOfUse>Terms of Use</termsOfUse>',
    id: 'D9dFs0XvGF',
    description:
      'Signup legal acknowledgement with links to usage policy, privacy policy, and terms of use',
  },
});
